import BaseApi from "./BaseApi";

export default class DiplomaService {

    static getToList() {
        return BaseApi.get(`/Diplomas/v1/list`);
    }

    static postVerify(code) {
        return BaseApi.post(`/Diplomas/v1/verify`, { code });
    }

    static getToVisualizar(diplomaId) {
        return BaseApi.get(`/Diplomas/v1/${diplomaId}`);
    }

    static getRvvdToDownloadByCodigoVerificador(codigoVerificador) {
        return BaseApi.get(`/Diplomas/v1/codigo/${codigoVerificador}/rvvd`);
    }

    static getRvvdToDownload(diplomaId) {
        return BaseApi.get(`/Diplomas/v1/${diplomaId}/rvvd`);
    }

    static getXmlToDownload(diplomaId) {
        return BaseApi.get(`/Diplomas/v1/${diplomaId}/xml`);
    }

}